import axios from 'axios'

const API_URL = process.env.REACT_APP_API_URL || ''

const api = axios.create({
  baseURL: API_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json'
  }
})

// Error handler
api.interceptors.response.use(
  response => response,
  error => {
    console.error('API Error:', error.response?.data || error.message)
    return Promise.reject(error)
  }
)

// Types
export interface OrderData {
  orderId: string
  amount: number
  currency: string
  state: 'pending' | 'processing' | 'completed' | 'expired' | 'cancelled'
  method: string
  recipient: string
  bankName: string
  address: string
  expiresAt: string
  createdAt: string
  qrData?: string
}

export interface PaymentLinkResponse {
  success: boolean
  paymentUrl: string
}

export interface SupportTicketResponse {
  success: boolean
  message: string
}

export interface ServerTimeResponse {
  timestamp: number
  iso: string
}

export interface FileData {
  name: string
  type: string
  data: string // base64
}

// Get order data
export const getOrderData = async (orderId: string): Promise<OrderData> => {
  const response = await api.get<OrderData>(`/api/order/${orderId}`)
  return response.data
}

// Generate payment link
export const generatePaymentLink = async (orderId: string, cvu: string): Promise<PaymentLinkResponse> => {
  const response = await api.post<PaymentLinkResponse>('/api/payment/link', { orderId, cvu })
  return response.data
}

// Create support ticket with photo
export const createSupportTicket = async (
  orderId: string, 
  file: FileData, 
  timeRemaining: number
): Promise<SupportTicketResponse> => {
  const response = await api.post<SupportTicketResponse>('/api/support/ticket', {
    orderId,
    file,
    timeRemaining
  })
  return response.data
}

// Get server time for synchronization
export const getServerTime = async (): Promise<ServerTimeResponse> => {
  const response = await api.get<ServerTimeResponse>('/api/time')
  return response.data
}

// Health check
export const checkHealth = async (): Promise<{ status: string; timestamp: number }> => {
  const response = await api.get('/health')
  return response.data
}

export default api

